import { useCallback, useState } from 'react';
import { loadFilters, saveFilters } from '@/shared/utils/filterStorage';
import { STORAGE_KEYS } from '../constants/riderStatus.constants';
import type { RiderFilterState } from '../types/riderStatus.types';

const DEFAULT_FILTERS: RiderFilterState = {
    centerId: '',
    riderName: '',
    riderId: '',
    phoneNum: '',
    contStatus: '',
};

export const useRiderFilter = () => {
    const [filters, setFilters] = useState<RiderFilterState>(() => {
        const saved = loadFilters<RiderFilterState>(STORAGE_KEYS.RIDER_STATUS_FILTERS);
        return saved || DEFAULT_FILTERS;
    });

    const handleFilterChange = useCallback((field: string, value: string) => {
        setFilters((prev) => ({ ...prev, [field]: value }));
    }, []);

    const persistFilters = useCallback(
        (currentFilters: RiderFilterState) => {
            saveFilters(STORAGE_KEYS.RIDER_STATUS_FILTERS, currentFilters);
        },
        [],
    );

    return { filters, setFilters, handleFilterChange, persistFilters };
};
